module.exports = __webpack_public_path__ + "img/left_right_layout_7.2190abd8.png";